import { createAsyncTypes } from 'utils/ActionCreator'

const typeKey = 'Dashboard/Threat Protection/Flow'

export const DATA_REQUEST_ASYNC = createAsyncTypes('DATA_REQUEST', typeKey)
export const TOP_PROFILES_REQUEST_ASYNC = createAsyncTypes('TOP_PROFILES_REQUEST', typeKey)
export const MITIGATION_REQUEST_ASYNC = createAsyncTypes('MITIGATION_REQUEST', typeKey)
export const MAILBOX_ANOMALY_REQUEST_ASYNC = createAsyncTypes('MAILBOX_ANOMALY_REQUEST', typeKey)
export const FETCH_ALL_FILTERS_ASYNC = createAsyncTypes('FETCH_ALL_FILTERS', `${typeKey}`)
export const MOST_ATTACKED_EMPLOYEES_REQUEST_ASYNC = createAsyncTypes(
  'MOST_ATTACKED_EMPLOYEES_REQUEST',
  typeKey
)

export const DATE_FILTER_CHANGE = `${typeKey}/DATE_FILTER_CHANGE`

export const RESET_FILTERS = `${typeKey}/RESET_FILTERS`

export const STARTER_DATA = {
  mailboxAnomaly: {
    'Known Address in Display Name': { quantity: 1 },
    'Company’s Name Appears in Display': { quantity: 18 },
    'Exact display Name Impersonation': { quantity: 133 },
    'Similar Display Name Impersonation': { quantity: 27 },
    'Sender Address Spoofing': { quantity: 13 },
  },
  preDelivery: {
    attachments: 1,
    malwareAndUrlProtection: 2,
    preDeliveryIncidents: 10,
    vision: 7,
  },
  postDeliveryAuto: {
    total: 789,
    fromUsers: 42,
    fromFederation: 354,
    fromMailboxAnomaly: 393,
    byThemis: 768,
    byMalwareAndUrlProtection: 19,
    byVs: 2,
    timeSaved: 443.9,
  },
}

export const INDUSTRY_AVG_RESOLUTION_TIME = 27.5
